import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentModule } from '../../../pipes/trust-content/trust-content.module';
import { ButtonModule } from '../../forms/button/button.module';
import { CheckboxStandardModule } from '../../forms/checkbox-standard/checkbox-standard.module';
import { DropdownModule } from '../../forms/dropdown/dropdown.module';
import { DropdownExpansionComponent } from './dropdown-expansion.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DropdownModule,
    CheckboxStandardModule,
    TrustContentModule
  ],
  declarations: [DropdownExpansionComponent],
  exports: [DropdownExpansionComponent]
})
export class DropdownExpansionModule {}
